// Govt Subsidy Categories — Biomass Zone
// Each category has a required-document checklist as shared by user

export const SUBSIDY_CATEGORIES = [
  {
    key: "HGUVY",
    code: "HGUVY",
    en: "H-GUVY Subsidy",
    hi: "H-GUVY सब्सिडी",
    tagline: "Haryana Green Udyog Vikas Yojana",
    color: "from-emerald-500 to-emerald-700",
    accent: "emerald",
    docs: [
      "Letter PAD",
      "Stamp",
      "GST Certificate",
      "Partnership Deed (Notarized)",
      "Partnership Registration Form A&C",
      "Plant & Machinery Bills",
      "Bank Payment Proof of Plant & Machinery",
      "Building Bills",
      "Bank Payment Proof of Building",
      "Building — Chartered Engineer Certificate",
      "Registry Copy / Lease Deed",
      "DTP NOC",
      "NOC from Gram Panchayat",
      "First Sale Bill",
      "UAM",
      "HUM",
      "Plant & Machinery Annexure in Books",
      "Building Annexure in Books",
      "Last Year GSTR-3B / Last Year Audit Balance Sheet",
      "Invest Haryana Portal ID & Password",
    ],
  },
  {
    key: "AIF",
    code: "AIF",
    en: "AIF Subsidy",
    hi: "AIF सब्सिडी",
    tagline: "Agri Infrastructure Fund",
    color: "from-amber-500 to-orange-600",
    accent: "amber",
    docs: [
      "PAN Card of Firm",
      "PAN Card of Partner",
      "Aadhar Card of Partners",
      "Email ID for Registration",
      "Mobile Number for Registration",
      "GST Certificate",
      "Partnership Deed",
      "Partnership Registration Form A&C",
      "Property Leased or Owned Information",
      "Project Report (Plant & Machinery + Raw & Finished Goods + Manufacturing Process)",
      "Photos of Unit with Krishi Mapper app (geo-tag location)",
      "Google Location of Unit",
      "Loanee Bank + IFSC Code",
    ],
  },
  {
    key: "STAMP_DUTY",
    code: "STAMP_DUTY",
    en: "Stamp Duty Refund",
    hi: "स्टाम्प ड्यूटी रिफंड",
    tagline: "Stamp Duty Reimbursement",
    color: "from-purple-500 to-indigo-600",
    accent: "purple",
    docs: [
      "Letter PAD",
      "Stamp",
      "GST Certificate",
      "Partnership Deed (Notarized)",
      "Partnership Registration Form A&C",
      "Registry Copy",
      "Intkal / Mutation",
      "Cizra",
      "DTP NOC",
      "NOC from Gram Panchayat",
      "First Sale Bill",
      "UAM",
      "HUM",
      "Cancelled Cross Cheque for Bank Details",
      "Map for Build-up Area Calculation",
      "Plant & Machinery Annexure in Books",
      "Building Annexure in Books",
      "Last Year GSTR-3B / Last Year Audit Balance Sheet",
      "Invest Haryana Portal ID & Password",
    ],
  },
  {
    key: "ELECTRIC_DUTY",
    code: "ELECTRIC_DUTY",
    en: "Electric Duty Exemption",
    hi: "बिजली शुल्क छूट",
    tagline: "Electricity Duty Exemption",
    color: "from-yellow-500 to-amber-600",
    accent: "yellow",
    docs: [
      "Letter PAD",
      "Stamp",
      "GST Certificate",
      "Partnership Deed (Notarized)",
      "Partnership Registration Form A&C",
      "Annexure II Signed by SDO",
      "DTP NOC",
      "NOC from Gram Panchayat",
      "UAM",
      "HUM",
      "Plant & Machinery Annexure in Books",
      "Building Annexure in Books",
      "Last Year GSTR-3B / Last Year Audit Balance Sheet",
      "Invest Haryana Portal ID & Password",
    ],
  },
  {
    key: "CPCB",
    code: "CPCB",
    en: "CPCB Subsidy",
    hi: "CPCB सब्सिडी",
    tagline: "Central Pollution Control Board",
    color: "from-sky-500 to-blue-600",
    accent: "sky",
    docs: [
      "Firm PAN Card + GST (Prop / Partners / Director KYC)",
      "Quotations with Sign & Stamp",
      "Land Lease Agreement or Registry",
      "Brief Project Report",
      "Undertaking for Non-Receipt of Central Subsidy",
      "Company Profile and Past Experience",
      "Copy of CTE Application submitted to SPCB/PCC",
      "Authorization Letter for Applicant on Company Letterhead",
      "Geo Tag Photos",
      "CTO Certificate",
      "Cancel Cheque",
    ],
  },
  {
    key: "ETP",
    code: "ETP",
    en: "ETP Subsidy",
    hi: "ETP सब्सिडी",
    tagline: "Effluent Treatment Plant",
    color: "from-teal-500 to-cyan-600",
    accent: "teal",
    docs: [
      "Firm PAN Card + GST",
      "Aadhar & PAN of Partners / Directors",
      "ETP Design / Layout & Capacity Details",
      "CTE / CTO from State Pollution Control Board",
      "Detailed Project Report (ETP)",
      "Plant & Machinery Bills (ETP)",
      "Bank Payment Proof of ETP Investment",
      "Water Analysis Report (Inlet & Outlet)",
      "Land Registry / Lease Deed",
      "Chartered Engineer Certificate",
      "Geo-tagged Photos of ETP Unit",
      "Cancelled Cheque for Bank Details",
      "Last Year GSTR-3B / Audit Balance Sheet",
    ],
  },
];

export const getSubsidy = (key) => SUBSIDY_CATEGORIES.find((s) => s.key === key);
